import { render, staticRenderFns } from "./DialogConfirm.vue?vue&type=template&id=7b40d472&scoped=true&"
import script from "./DialogConfirm.vue?vue&type=script&lang=ts&"
export * from "./DialogConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b40d472",
  null
  
)

export default component.exports